/* eslint-disable no-undef */
import { useSearchSelectContext } from 'js/components/higherOrderComponents/search/SearchResultsWithItemSelection';
import MapIcons from 'js/constants/mapIcon';

export default (props) => {
    const multiSelect = useSearchSelectContext();
    const type = props.type ?? 'all';
    const scaledSize = new google.maps.Size(35, 35);

    const get = (properties) => ({
        scaledSize,
        url: multiSelect?.itemSelected?.some(id => properties?.map(p => p.id).includes(id))
            ? MapIcons.ICON_BY_STATUS[type].selected
            : MapIcons.ICON_BY_STATUS[type].basic,
        size: new google.maps.Size(35, 35),
        origin: new google.maps.Point(0, -2),
    });


    const getTargetProperty = () => ({
        scaledSize,
        url: MapIcons.ICON_BY_STATUS.targetProperty.basic,
        origin: new google.maps.Point(0, 0),
        size: new google.maps.Size(60, 60),
    });

    return {
        get, getTargetProperty,
    };
}
